import { Injectable } from '@angular/core';
import { CognitoUserInterface } from '@shared/meta-data';
import mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsManagerService {
  acceptedEnvironments: string[] = [];

  constructor() {
    this.acceptedEnvironments = ['dev', 'production'];
  }

  private isEnvironmentAccepted(): boolean {
    return this.acceptedEnvironments.includes(environment.NAME);
  }

  async init(): Promise<void> {
    if (!this.isEnvironmentAccepted()) {
      return;
    }

    this.initMixPanel();
  }

  sendEvent(eventName: string, properties: object): void {
    if (!this.isEnvironmentAccepted()) {
      return;
    }

    this.trackMixPanelEvent(eventName, properties);
  }

  identifyUser(cognitoUser: CognitoUserInterface): void {
    if (!this.isEnvironmentAccepted()) {
      return;
    }

    const { sub, email, given_name, family_name } = cognitoUser;
    this.identifyMixPanelUser({ sub, email, given_name, family_name });
  }

  reset(): void {
    if (!this.isEnvironmentAccepted()) {
      return;
    }

    this.resetMixPanel();
  }

  /**
   * Mix Panel
   */

  private initMixPanel() {
    mixpanel.init(environment.MIX_PANEL_TOKEN, {
      debug: !environment.production,
      track_pageview: true,
      persistence: 'localStorage',
    });
  }

  private identifyMixPanelUser(
    { sub, email, given_name, family_name }: { sub: string; email: string; given_name: string; family_name?: string },
  ) {
    // Use the stable Cognito `sub` as the Mixpanel distinct_id so identity survives email changes.
    mixpanel.identify(sub || email);
    mixpanel.people.set({ $email: email, $first_name: given_name, $last_name: family_name });
  }

  private trackMixPanelEvent(eventName: string, properties?: object): void {
    mixpanel.track(eventName, properties);
  }

  private resetMixPanel() {
    mixpanel.reset();
  }
}
